import {createTheme, responsiveFontSizes} from "@material-ui/core";

export let light = createTheme({
    palette: {
        type: "light",
        primary: {
            main: '#0b78d0',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#f93939',
            contrastText: '#ffffff',
        },
    },
    overrides: {
        MuiButton: {
            containedPrimary: {
                backgroundColor: '#0b78d0',
                color: '#ffffff',
                '&:hover': {
                    backgroundColor: '#1c6daf',
                },
            },
            containedSecondary: {
                backgroundColor: '#f93939',
                color: '#ffffff',
                '&:hover': {
                    backgroundColor: '#d03030',
                },
            }
        },
        MuiBadge: {
            root: {},
            dot: {},
            badge: {},
        },
    },
    props: {
        MuiBadge: {
            overlap: 'rectangular',
        }
    },
});

light = responsiveFontSizes(light);
